<template>
  <v-row no-gutters class="style-preview" align="center" justify="center">
    <v-col cols="7" class="style-preview-draw-box d-flex justify-center">
      <span class="draw-box-cross-top-left" />
      <span class="draw-box-cross-bottom-right" />
      <template v-if="isStyleValid">
        <template v-if="geometryType === 'linestring'">
          <svg
            width="200px"
            class="line-draw"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <line
              x1="0"
              y1="59"
              x2="200"
              y2="59"
              :opacity="layerStyle['fill-opacity']"
              :stroke="layerStyle['line-color']"
              :stroke-width="layerStyle['line-width']"
              stroke-linecap="round"
              :stroke-dasharray="linestringDashArray"
            />
          </svg>
        </template>
        <template v-else-if="geometryType === 'point'">
          <template v-if="layerStyle.externalGraphic">
            <img
              :width="`${layerStyle['icon-size'] * 20}px`"
              :height="`${layerStyle['icon-size'] * 20}px`"
              :style="iconDrawStyle"
              :src="getIcon(layerStyle.externalGraphic)"
              class="icon-draw"
            />
          </template>
          <template v-else>
            <span :style="pointDrawStyle" class="point-draw" />
          </template>
        </template>
        <template v-else-if="geometryType === 'polygon'">
          <span class="inner-draw-box-cross-top-left" />
          <span class="inner-draw-box-cross-bottom-right" />
          <span class="inner-polygon-draw" />
          <span :style="polygonDrawStyle" class="polygon-draw" />
          <span :style="polygonDrawStrokeStyle" class="polygon-draw-stroke" />
        </template>
      </template>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'StyleDialogStylePreview',
  props: {
    geometryType: {
      type: String,
      required: true,
    },
    isStyleValid: {
      type: Boolean,
      defalt: () => {
        return false;
      },
    },
    layerStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    iconDrawStyle() {
      const style = {};
      style['opacity'] = `${this.layerStyle['fill-opacity'] * 100}%`;
      style['margin-top'] = `${60 - this.layerStyle['icon-size'] * 10}px`;
      return style;
    },
    linestringDashArray() {
      let dashArray = [...this.layerStyle['line-dash']];
      if (dashArray.length > 0) {
        const lastElement = dashArray[dashArray.length - 1];
        if (dashArray[dashArray.length - 2] === 1) {
          if (dashArray.length === 3) {
            dashArray[dashArray.length - 1] =
              dashArray[dashArray.length - 2] * this.layerStyle['line-width'] + lastElement;
            dashArray[0] = dashArray[dashArray.length - 2] * this.layerStyle['line-width'] + lastElement;
          } else {
            dashArray[dashArray.length - 1] =
              dashArray[dashArray.length - 2] * this.layerStyle['line-width'] + dashArray[dashArray.length - 1];
          }
        } else {
          dashArray[dashArray.length - 1] = dashArray[dashArray.length - 1] + this.layerStyle['line-width'];
        }
      }
      return dashArray;
    },
    pointDrawStyle() {
      const style = {};
      style['background-color'] = `${this.layerStyle['circle-color']}`;
      style['opacity'] = `${this.layerStyle['fill-opacity'] * 100}%`;
      style['width'] = `${this.layerStyle['circle-radius'] * 2}px`;
      style['height'] = `${this.layerStyle['circle-radius'] * 2}px`;
      style['margin-top'] = `${(120 - this.layerStyle['circle-radius'] * 2) / 2}px`;
      return style;
    },
    polygonDrawStyle() {
      const style = {};
      style['background-color'] = `${this.layerStyle['fill-color']}`;
      style['opacity'] = `${this.layerStyle['fill-opacity'] * 100}%`;
      return style;
    },
    polygonDrawStrokeStyle() {
      const style = {};
      style['background-color'] = `${this.layerStyle['fill-outline-color']}`;
      style['opacity'] = `${this.layerStyle['fill-outline-opacity'] * 100}%`;
      style['width'] = `${this.layerStyle['line-width'] * 2 + 40}px`;
      style['height'] = `${this.layerStyle['line-width'] * 2 + 40}px`;
      style['top'] = `${40 - this.layerStyle['line-width']}px`;
      return style;
    },
  },
  methods: {
    getIcon(name) {
      return `${process.env.VUE_APP_API_URL}/icons/${name}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.style-preview {
  @include border(top, 1px, rgba(32, 33, 36, 0.18));
  height: 200px;
}
.style-preview-draw-box {
  height: 120px;
  border: 0.8px solid #898989;
  position: relative;
  z-index: 1;
}
.draw-box-cross-top-left {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 10px;
  left: calc(50% - 49px);
  border-right: 1px solid #898989;
  border-bottom: 1px solid #898989;
  z-index: 2;
}
.draw-box-cross-bottom-right {
  position: absolute;
  width: 50px;
  height: 50px;
  bottom: 9px;
  right: calc(50% - 50px);
  border-left: 1px solid #898989;
  border-top: 1px solid #898989;
  z-index: 2;
}
.polygon-draw {
  width: 40px;
  height: 40px;
  display: inline-block;
  z-index: 6;
  margin-top: 40px;
}
.polygon-draw-stroke {
  position: absolute;
  z-index: 3;
  border-style: dotted;
  border-color: transparent;
}
.inner-draw-box-cross-top-left {
  background-color: transparent;
  position: absolute;
  width: 21px;
  height: 20px;
  top: 40px;
  left: calc(50% - 20px);
  border-right: 1px solid #898989;
  border-bottom: 1px solid #898989;
  z-index: 5;
}
.inner-draw-box-cross-bottom-right {
  background-color: transparent;
  position: absolute;
  width: 20px;
  height: 21px;
  bottom: 38px;
  right: calc(50% - 20px);
  border-left: 1px solid #898989;
  border-top: 1px solid #898989;
  z-index: 5;
}
.inner-polygon-draw {
  position: absolute;
  width: 40px;
  height: 40px;
  display: inline-block;
  z-index: 4;
  margin-top: 40px;
  background-color: white;
}
.line-draw {
  z-index: 6;
}
.point-draw {
  border-radius: 50%;
  z-index: 3;
}
.icon-draw {
  z-index: 3;
}
</style>
